package horcrux.frontend.common.clients.backendclient

import horcrux.common.HorcruxEither
import horcrux.common.ServerAppRoute
import horcrux.common.utils.runIOAndCatch
import horcrux.frontend.common.clients.AuthenticationClient
import horcrux.frontend.common.configs.ApplicationConfigs
import horcrux.frontend.common.extensions.url
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.ResponseException
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.request
import io.ktor.client.request.url
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.HttpStatusCode
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

open class BackendClient {
    protected fun getClient(block: HttpClientConfig<*>.() -> Unit) = HttpClient {
        this.expectSuccess = true
        install(Logging) {
            this.level = ApplicationConfigs.LOG_LEVEL
        }
        install(ContentNegotiation) {
            json(Json {
                this.ignoreUnknownKeys = true
            })
        }
        block()
    }

    protected suspend fun submitAndHandleErrors(block: suspend () -> HttpResponse): HorcruxEither<HttpResponse> {
        return runIOAndCatch {
            val httpResponse = block()
            if (httpResponse.status == HttpStatusCode.Unauthorized) {
                throw AuthenticationClient.UnauthenticatedException()
            }
            httpResponse
        }.mapLeft { cause ->
            when (cause) {
                is ResponseException -> if (cause.response.status == HttpStatusCode.Unauthorized) {
                    AuthenticationClient.UnauthenticatedException()
                } else {
                    cause
                }

                else -> cause
            }
        }
    }

    protected suspend fun HttpClient.submit(
        httpMethod: HttpMethod, serverAppRoute: ServerAppRoute, block: HttpRequestBuilder.() -> Unit = {}
    ): HttpResponse = request {
        this.method = httpMethod
        this.url(serverAppRoute.url)
        block()
    }

    protected fun HttpRequestBuilder.stringParameter(key: String, value: String): Unit =
        parameter(key, value)
}
